import React, { useState, ChangeEvent, FormEvent } from 'react'
import { Paper, InputBase, IconButton } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

// @ts-expect-error - Import needs esModuleInterop flag
import { useTranslation } from '@contexts/translation'

interface CustomSearchInputProps {
  /** Current value of the search input */
  value: string
  /** Handler function for when the input value changes */
  handleChange: (event: ChangeEvent<HTMLInputElement>) => void
}

/**
 * CustomSearchInput component
 * A search input with a search icon
 */
const CustomSearchInput = ({
  value,
  handleChange
}: CustomSearchInputProps): JSX.Element => {
  const { dictionary } = useTranslation()

  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setIsOpen(!isOpen)
  }

  return (
    <Paper
      component="form"
      sx={{
        height: '37px',
        borderRadius: t => t.spacing(2),
        p: '6px 0 6px 5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: 250,
        border: t => `1px solid ${t.palette.other.stroke}`,
        transition: 'all 300ms ease'
      }}
      onSubmit={handleSubmit}
    >
      <IconButton
        sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        data-testid="IconButton-8eec3107-c011-46b1-a417-d2be893e7bc5"
      >
        <SearchIcon sx={{ color: 'text.light' }} />
      </IconButton>
      <InputBase
        sx={{ flex: 1, color: t => t.palette.text.primary }}
        placeholder={dictionary.search?.toString() || 'Search'}
        value={value}
        onChange={handleChange}
        data-testid="InputBase-3ae1f35d-1861-47d9-90f8-45221d2546e3"
      />
    </Paper>
  )
}

export default CustomSearchInput
